import { IInitEventDisruptionProtocol } from 'ngx-mt-ui-lib/api-client';
import { Action } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import { mapEventCardProtocolsSnapshot } from './event-card-protocol.mapper';
import { EventCardActions } from './state/event-card.actions';

export interface IEventCardGanttDedupState {
  lastGanttKey: string | null;
}

// Общий dedup для REST и WS: повторяем запрос только при изменении данных диаграммы.
// Сброс через resetEventCardGanttDedup при stop/watch — новая карточка снова может запросить gantt.
const ganttDedupState: IEventCardGanttDedupState = {
  lastGanttKey: null,
};

export function resetEventCardGanttDedup(): void {
  ganttDedupState.lastGanttKey = null;
}

export function buildEventCardProtocolsSyncActions(
  disruptionId: number,
  protocols: IInitEventDisruptionProtocol[],
  translateService: Pick<TranslateService, 'instant'>,
  ganttDedup: IEventCardGanttDedupState = ganttDedupState,
): Action[] {
  const snapshot = mapEventCardProtocolsSnapshot(protocols, translateService);
  const actions: Action[] = [
    EventCardActions.eventCardDisruptionProtocolsSnapshot({
      disruptionId,
      ...snapshot,
    }),
  ];

  const active = snapshot.activeProtocolInfo;
  if (!active?.id || !active.launchDate) {
    ganttDedup.lastGanttKey = null;
    return actions;
  }

  const ganttKey = JSON.stringify({
    disruptionId,
    protocolId: active.id,
    launchDate: active.launchDate,
    completionDate: active.completionDate,
    steps: [...snapshot.activeProtocolSteps]
      .sort((left, right) => left.id - right.id)
      .map((step) => ({
        id: step.id,
        stepNumber: step.stepNumber,
        stepName: step.stepName,
        reactRoleShortName: step.reactRoleShortName,
        slaMinutes: step.slaMinutes,
        stateCode: step.stateCode,
        stateDate: step.stateDate,
        assignmentConditionCode: step.assignmentConditionCode,
        parentStepId: step.parentStepId,
        assignmentDelayMinutes: step.assignmentDelayMinutes,
      })),
  });
  if (ganttDedup.lastGanttKey === ganttKey) {
    return actions;
  }

  ganttDedup.lastGanttKey = ganttKey;
  actions.push(
    EventCardActions.requestEventActiveProtocolGantt({
      eventId: disruptionId,
      protocolId: active.id,
      protocolLaunchDate: active.launchDate,
    }),
  );

  return actions;
}
